// This file's own <script src> tag is embedded inline inside
// snippets/quantity-product-card.liquid, which also renders the cart
// drawer's recommended-products carousel - so any dynamic HTML refresh
// that re-inserts that snippet (e.g. pdp-bundle-instant-checkout.js's
// cart-drawer section swap) re-inserts this <script> tag too. Browsers
// re-execute dynamically-inserted scripts regardless of `defer`, which
// crashed with "Identifier 'initializedForms' has already been
// declared" on every refresh after the first. Guarded so a re-execution
// is a harmless no-op instead: the MutationObserver at the bottom of
// this file already re-initializes any newly-inserted quantity
// selectors on its own, so nothing here needs to run twice anyway.
if (!window.__quantityProductCardScriptLoaded) {
  window.__quantityProductCardScriptLoaded = true;

const initializedForms = new Set();

function getTotalVariantQuantity(cart, variantId) {
  if (!cart || !cart.items || !Array.isArray(cart.items)) {
    return 0;
  }
  
  const searchVariantId = String(variantId);
  
  const totalQuantity = cart.items.reduce((sum, item) => {
    const itemVariantId = String(item.variant_id);
    if (itemVariantId === searchVariantId) {
      return sum + (item.quantity || 0);
    }
    return sum;
  }, 0);
  
  return totalQuantity;
}

function getTotalProductQuantityInCart(cart, productId) {
  if (!cart || productId == null || productId === "") return 0;
  const pid = String(productId);
  const items = Array.isArray(cart.items) ? cart.items : [];
  return items.reduce((sum, item) => {
    const itemPid = item.product_id != null ? String(item.product_id) : "";
    if (itemPid === pid) return sum + (parseInt(item.quantity, 10) || 0);
    return sum;
  }, 0);
}

function getFirstCartItemForVariant(cart, variantId) {
  if (!cart || !cart.items || !Array.isArray(cart.items)) {
    return null;
  }
  
  const searchVariantId = String(variantId);
  return cart.items.find(item => String(item.variant_id) === searchVariantId) || null;
}

function isVariantInCart(cart, variantId) {
  return getTotalVariantQuantity(cart, variantId) > 0;
}

function setButtonLoading(button, isLoading) {
  if (!button) return;

  if (isLoading) {
    button.setAttribute("aria-busy", "true");
    button.classList.add("btn-shine");
  } else {
    button.removeAttribute("aria-busy");
    button.classList.remove("btn-shine");
  }
}

function initQuantitySelector() {
  const quickAddContainers = document.querySelectorAll(
    ".quick-add[data-product-id]"
  );

  quickAddContainers.forEach((container) => {
    const productId = container.dataset.productId;
    const variantId = container.dataset.variantId;
    const maxProductQty = container.dataset.maxProductQuantity ? parseInt(container.dataset.maxProductQuantity, 10) : null;
    const priceInput = container.querySelector('input[name="price"]');
    const typeInput = container.querySelector('input[name="type"]');
    const quantityInputField = container.querySelector('input[name="quantity"]');
    const atcBtn = container.querySelector(".atc-btn");
    const qtySelector = container.querySelector(".qty-selector");
    const qtyInput = container.querySelector(".qty-input");
    const qtyMinus = container.querySelector(".qty-minus");
    const qtyPlus = container.querySelector(".qty-selector .qty-plus") || container.querySelector("button.qty-plus") || container.querySelector(".qty-plus");
    const form = container.querySelector(".quick-add-form");

    if (!atcBtn || !qtySelector || !form) return;

    const formId = form.id;
    if (initializedForms.has(formId)) return;
    initializedForms.add(formId);

    const qtyLoader = document.createElement("span");
    qtyLoader.className = "plp-qty-loader";
    qtyLoader.innerHTML =
      '<svg fill="#171717FF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width:16px;height:16px;display:block;"><path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/></path></svg>';
    qtyLoader.style.display = "none";
    qtyLoader.style.position = "absolute";
    qtyLoader.style.left = "50%";
    qtyLoader.style.top = "50%";
    qtyLoader.style.transform = "translate(-50%, -50%)";
    qtyLoader.style.pointerEvents = "none";
    if (qtySelector) {
      const computedPos = window.getComputedStyle(qtySelector).position;
      if (computedPos === "static") {
        qtySelector.style.position = "relative";
      }
      qtySelector.appendChild(qtyLoader);
    }

    function setQuantityLoading(isLoading) {
      if (!qtyLoader) return;
      qtyLoader.style.display = isLoading ? "flex" : "none";
      if (qtyInput) qtyInput.style.visibility = isLoading ? "hidden" : "visible";
      if (qtyInput) qtyInput.disabled = isLoading;
      if (qtyMinus) qtyMinus.disabled = isLoading;
      if (qtyPlus) qtyPlus.disabled = isLoading;
    }

    function updateFromCart(cart) {
      const totalQuantity = getTotalVariantQuantity(cart, variantId);
      if (totalQuantity > 0) {
        atcBtn.classList.add("hidden");
        qtySelector.classList.remove("hidden");
        qtyInput.value = totalQuantity;
      } else {
        atcBtn.classList.remove("hidden");
        qtySelector.classList.add("hidden");
        qtyInput.value = 1;
      }
      if (maxProductQty != null && cart && Array.isArray(cart.items)) {
        const productQtyInCart = getTotalProductQuantityInCart(cart, productId);
        container.dataset.productQuantityInCart = productQtyInCart;
        const atMax = productQtyInCart >= maxProductQty;
        if (atcBtn) atcBtn.disabled = atMax;
        const allPlusBtns = container.querySelectorAll(".qty-selector .qty-plus, button.qty-plus");
        allPlusBtns.forEach((btn) => { btn.disabled = atMax; });
        const qtyBtnPlusBtns = container.querySelectorAll(".qty-btn.qty-plus");
        qtyBtnPlusBtns.forEach((btn) => {
          if (atMax) {
            btn.removeAttribute('disabled');
            btn.setAttribute('aria-disabled', 'true');
            btn.classList.add('qty-btn--disabled');
          } else {
            btn.removeAttribute('aria-disabled');
            btn.removeAttribute('disabled');
            btn.classList.remove('qty-btn--disabled');
          }
        });
        if (qtyPlus && !qtyPlus.classList.contains('qty-btn')) {
          qtyPlus.disabled = atMax;
        } else if (qtyPlus) {
          if (atMax) {
            qtyPlus.removeAttribute('disabled');
            qtyPlus.setAttribute('aria-disabled', 'true');
            qtyPlus.classList.add('qty-btn--disabled');
          } else {
            qtyPlus.removeAttribute('aria-disabled');
            qtyPlus.removeAttribute('disabled');
            qtyPlus.classList.remove('qty-btn--disabled');
          }
        }
        if (qtyInput && !isNaN(maxProductQty)) qtyInput.max = maxProductQty;
      }
    }

    (function initialSync() {
      const currentCart =
        typeof user_cart !== "undefined" && user_cart ? user_cart : null;
      if (currentCart) {
        updateFromCart(currentCart);
        return;
      }
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          if (typeof user_cart !== "undefined") {
            user_cart = cart;
          }
          updateFromCart(cart);
        })
        .catch((error) => console.error("Error checking cart:", error));
    })();

    document.addEventListener("cart:updated", (event) => {
      const eventCartData = event?.detail?.cart || null;
      if (eventCartData) {
        updateFromCart(eventCartData);
        setButtonLoading(atcBtn, false);
        if (qtyMinus) setButtonLoading(qtyMinus, false);
        if (qtyPlus) setButtonLoading(qtyPlus, false);
        setQuantityLoading(false);
      }
    });

    const handleSubmit = function (e) {
      e.preventDefault();
      if (maxProductQty != null && atcBtn && atcBtn.disabled) return;
      setButtonLoading(atcBtn, true);

      const price = priceInput ? Number(priceInput.value) || 0 : 0;
      const productType = typeInput ? typeInput.value : "";
      const qtyFieldValue = quantityInputField
        ? quantityInputField.value
        : qtyInput.value;
      const formQty = parseInt(qtyFieldValue || "1", 10) || 1;

      if (typeof cartGiftUpdate === "function") {
        cartGiftUpdate(variantId, price, formQty, productType, "ADD_TO_CART");
      } else {
        form.submit();
      }
    };

    form.addEventListener("submit", handleSubmit, { once: false });

    if (qtyMinus) {
      qtyMinus.addEventListener("click", function (e) {
        e.preventDefault();
        setButtonLoading(qtyMinus, true);
        setQuantityLoading(true);
        const currentQty = parseInt(qtyInput.value) || 1;
        const price = priceInput ? Number(priceInput.value) || 0 : 0;
        const productType = typeInput ? typeInput.value : "";

        if (currentQty > 1) {
          qtyInput.value = currentQty - 1;
          if (typeof cartGiftUpdate === "function") {
            cartGiftUpdate(variantId, price, 1, productType, "REMOVED_FROM_CART");
          }
        } else if (currentQty === 1) {
          qtyInput.value = 0;
          if (typeof cartGiftUpdate === "function") {
            cartGiftUpdate(variantId, price, 1, productType, "REMOVED_FROM_CART");
          }
        }
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener("click", function (e) {
        e.preventDefault();
        if (qtyPlus.disabled) return;
        setButtonLoading(qtyPlus, true);
        setQuantityLoading(true);
        const currentQty = parseInt(qtyInput.value) || 1;
        const price = priceInput ? Number(priceInput.value) || 0 : 0;
        const productType = typeInput ? typeInput.value : "";
        if (maxProductQty != null && currentQty >= maxProductQty) return;
        qtyInput.value = currentQty + 1;

        if (typeof cartGiftUpdate === "function") {
          cartGiftUpdate(variantId, price, 1, productType, "ADD_TO_CART");
        }
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener("change", function () {
        const newQty = parseInt(this.value) || 1;
        const price = priceInput ? Number(priceInput.value) || 0 : 0;
        const productType = typeInput ? typeInput.value : "";

        const currentCart =
          typeof user_cart !== "undefined" && user_cart ? user_cart : null;
        const currentTotal = currentCart
          ? getTotalVariantQuantity(currentCart, variantId)
          : 0;

        const diff = newQty - currentTotal;
        if (!diff) {
          this.value = newQty || 1;
          return;
        }

        this.value = newQty || 1;

        if (typeof cartGiftUpdate === "function") {
          setQuantityLoading(true);
          if (diff > 0) {
            cartGiftUpdate(variantId, price, diff, productType, "ADD_TO_CART");
          } else {
            cartGiftUpdate(
              variantId,
              price,
              Math.abs(diff),
              productType,
              "REMOVED_FROM_CART"
            );
          }
        }
      });
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initQuantitySelector);
} else {
  initQuantitySelector();
}

const observer = new MutationObserver(() => {
  initQuantitySelector();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

}

